import React from "react";
import * as Sentry from "@sentry/react";
import { useI18n } from "../i18n";

function ErrorFallback() {
  const { t } = useI18n();

  return (
    <main className="app-error-boundary" role="alert">
      <h1>{t("errorBoundary.title")}</h1>
      <p>{t("errorBoundary.message")}</p>
      <button type="button" onClick={() => window.location.reload()}>
        {t("errorBoundary.reload")}
      </button>
    </main>
  );
}

class AppErrorBoundary extends React.Component {
  state = { hasError: false };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    Sentry.captureException(error, { contexts: { react: errorInfo } });
  }

  render() {
    return this.state.hasError ? <ErrorFallback /> : this.props.children;
  }
}

export default AppErrorBoundary;
